"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Input;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Element = _interopRequireDefault(require("../Element"));
var _excluded = ["active", "className", "color", "focused", "fullwidth", "hovered", "inline", "rounded", "size"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var colors = ['primary', 'link', 'info', 'success', 'warning', 'danger', 'white', 'black', 'light', 'dark'];
var colorMap = {
  primary: 'is-primary',
  link: 'is-link',
  info: 'is-info',
  success: 'is-success',
  warning: 'is-warning',
  danger: 'is-danger',
  white: 'is-white',
  black: 'is-black',
  light: 'is-light',
  dark: 'is-dark'
};
var sizes = ['small', 'medium', 'large'];
var sizeMap = {
  small: 'is-small',
  medium: 'is-medium',
  large: 'is-large'
};
function Input(_ref) {
  var active = _ref.active,
    className = _ref.className,
    color = _ref.color,
    focused = _ref.focused,
    fullwidth = _ref.fullwidth,
    hovered = _ref.hovered,
    inline = _ref.inline,
    rounded = _ref.rounded,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var isColor = color && colorMap[color];
  var isSize = size && sizeMap[size];
  var classes = (0, _classnames["default"])('input', className, isColor, isSize, {
    'is-inline': inline,
    'is-fullwidth': fullwidth,
    'is-active': active,
    'is-rounded': rounded,
    'is-hovered': hovered,
    'is-focused': focused,
    'is-static': props["static"]
  });

  // eslint-disable-next-line
  delete props["static"];
  return /*#__PURE__*/_react["default"].createElement(_Element["default"], _extends({
    className: classes
  }, props));
}
Input.propTypes = {
  className: _propTypes["default"].string,
  component: _propTypes["default"].elementType,
  type: _propTypes["default"].oneOf(['text', 'password', 'email', 'tel']),
  color: _propTypes["default"].oneOf(colors),
  size: _propTypes["default"].oneOf(sizes),
  inline: _propTypes["default"].bool,
  fullwidth: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  rounded: _propTypes["default"].bool,
  hovered: _propTypes["default"].bool,
  focused: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  "static": _propTypes["default"].bool
};
Input.defaultProps = {
  className: undefined,
  component: 'input',
  type: undefined,
  color: undefined,
  size: undefined,
  inline: false,
  fullwidth: false,
  active: false,
  rounded: false,
  hovered: false,
  focused: false,
  disabled: false,
  readOnly: false,
  "static": false
};